var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDexaExp = function SvgDexaExp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dexa-exp_svg__a)",
    d: "M56.667 53.333 43.333 40V29.4C47.2 28 50 24.333 50 20c0-5.533-4.467-10-10-10s-10 4.467-10 10c0 4.333 2.8 8 6.667 9.4V40L23.333 53.333H10V70h16.667V59.833l13.333-14 13.333 14V70H70V53.333z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dexa-exp_svg__a",
    x1: -15.025,
    x2: 65.248,
    y1: -12.5,
    y2: 67.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BA4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14497B"
  })))));
};
export { SvgDexaExp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTU2LjY2NjcgNTMuMzMzM0w0My4zMzMzIDQwVjI5LjRDNDcuMiAyOCA1MCAyNC4zMzMzIDUwIDIwQzUwIDE0LjQ2NjcgNDUuNTMzMyAxMCA0MCAxMEMzNC40NjY3IDEwIDMwIDE0LjQ2NjcgMzAgMjBDMzAgMjQuMzMzMyAzMi44IDI4IDM2LjY2NjcgMjkuNFY0MEwyMy4zMzMzIDUzLjMzMzNIMTBWNzBIMjYuNjY2N1Y1OS44MzMzTDQwIDQ1LjgzMzNMNTMuMzMzMyA1OS44MzMzVjcwSDcwVjUzLjMzMzNINTYuNjY2N1oiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8zOTZfMjUzOCkiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8zOTZfMjUzOCIgeDE9Ii0xNS4wMjQ4IiB5MT0iLTEyLjUiIHgyPSI2NS4yNDc1IiB5Mj0iNjcuNzcyMyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNUJBNEVBIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzE0NDk3QiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";